module.exports = __webpack_public_path__ + "assets/img/66_519_3.1865a459.jpg";